import { Controller } from '@hotwired/stimulus'

// Due to inconsistent mounting behavior the click actions is not mounted on the collapsable items.
export default class extends Controller {
  connect () {
    const container = this.element
    container.addEventListener('click', function (event) {
      const summary = event.target.closest('summary')
      if (!!summary) {
        const detailsTarget = summary.closest('details')
        container.querySelectorAll('details[open]').forEach(details => {
          if (details !== detailsTarget) details.open = false
        })
      }
    })
  }
}
